module.exports = __webpack_public_path__ + "static/image5-cf047e317af079d7ab973eed7299fd57.jpg";